import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';
import { FormattedMessage } from 'react-intl';

import { FeedbackOptionWrapper } from './Style';

interface ChatFeedbackProps {
  iconName: string;
  iconClass: string;
  tooltip: string;
  additionalClass?: string;
  isActive: boolean;
  clickAction: (icon: string, message: string) => void;
  dataTestId?: string;
}

export const ChatFeedbackOptions = ({
  iconName,
  iconClass,
  tooltip,
  additionalClass,
  isActive,
  clickAction,
  dataTestId,
}: ChatFeedbackProps) => {
  const handleClick = (icon: string) => clickAction(icon, tooltip);

  return (
    <FeedbackOptionWrapper className={`${additionalClass || ''} ${isActive ? 'active' : ''}`} data-testid={iconClass}>
      <OverlayTrigger
        placement="bottom"
        overlay={
          <Tooltip id="tooltip" allowOnTouch>
            <FormattedMessage id={tooltip} />
          </Tooltip>
        }
      >
        <span className={`rioglyph ${iconClass}`} onClick={() => handleClick(iconName)} data-testid={dataTestId} />
      </OverlayTrigger>
    </FeedbackOptionWrapper>
  );
};
